export const POSTS = [
  {
    slug: "referrals-arent-a-pipeline",
    title: "Referrals aren't a pipeline",
    excerpt:
      "Referrals built your recruitment firm. They won't scale it. Here's the two-channel system that turns outreach into 10+ qualified meetings a month.",
    date: "September 2026",
    readTime: "2 min read",
    body: [
      "Every IT recruitment firm grows the same way: a founder, a network, word of mouth. It works — until you need growth on a schedule.",
      "A pipeline means knowing how many sales conversations will happen next month, because you created them. For recruitment firms, that comes down to two channels done properly: LinkedIn and cold email.",
      "The proof is in the numbers: one recent campaign reached 609 prospects with a 59.61% open rate and 25 positive replies — and most arrived after the third or fourth follow-up, the messages manual prospecting never sends.",
      "So measure three things: replies, positive replies, and meetings booked. Referrals are a bonus. A pipeline is the business.",
    ],
  },
  {
    slug: "what-a-033-bounce-rate-tells-your-clients",
    title: "What a 0.33% bounce rate tells your clients",
    excerpt:
      "Across 2,120 cold emails we sent, 7 bounced. That tiny number says everything about how outreach should be run — and why your domain stays safe.",
    date: "September 2026",
    readTime: "2 min read",
    body: [
      "2,120 cold emails sent across six campaigns. Seven bounced. That 0.33% bounce rate is the most important trust signal in outreach.",
      "High bounces tell email providers you're blasting bad lists — and soon everything from your domain lands in spam, including client emails and invoices.",
      "Near-zero bounces come from discipline: verified addresses, hand-built lists, dedicated warmed sending accounts, strict daily limits. Your domain is never touched.",
      "That discipline is what sits underneath a 59.61% open rate and 25 positive replies. So ask anyone running outreach for you one question first: what's your bounce rate?",
    ],
  },
];
